import * as TYPES from './language-actiontypes';
import { persistStateToLocal } from '../../webstorage';

export const translationsLoadedSuccess = (translations) => (
  {
    type: TYPES.TRANSLATIONS_LOADED_SUCCESS,
    translations,
  }
);
export const LOCAL_STORAGE_KEY = 'patient:language';
export const languageTranslationsLoaded = (languageTranslations) => ({
  type: TYPES.LANGUAGE_TRANSLATIONS_LOAD_SUCCEEDED,
  languageTranslations,
});

export const translationsLoadFailed = () => (
  {
    type: TYPES.TRANSLATIONS_LOAD_FAILED,
    translations: null,
  }
);

export const changeLanguageState = (lang) => {
  const state = {
    languageCode: lang,
  };

  persistStateToLocal(LOCAL_STORAGE_KEY, state);

  return {
    type: TYPES.LANGUAGE_CHANGE,
    state,
  };
};